import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import './App.css';
import MapComponent from './components/map/baseMap';
import "./leaflet.css";
import LoginComponent from './components/login/loginComponent';
import ProtectedRoute from './components/protectedRouteComponent';
import useAuth from './hooks/useAuth';
import SessionTimer from './components/login/SessionTimer';

function App() {
    const [isFormSubmenuOpen, setIsFormSubmenuOpen] = useState(false);
    const [isRequestSubmenuOpen, setIsRequestSubmenuOpen] = useState(false);
    // const [timeLeft, setTimeLeft] = useState(0);

    const handleFormButtonClick = () => {
        setIsFormSubmenuOpen(!isFormSubmenuOpen);
        setIsRequestSubmenuOpen(false);
    };

    const handleRequestButtonClick = () => {
        setIsRequestSubmenuOpen(!isRequestSubmenuOpen);
        setIsFormSubmenuOpen(false);
    };

    return (
        <Router>
            <AppContent 
                isFormSubmenuOpen={isFormSubmenuOpen} 
                setIsFormSubmenuOpen={setIsFormSubmenuOpen}
                handleFormButtonClick={handleFormButtonClick}
                handleRequestButtonClick={handleRequestButtonClick}
                isRequestSubmenuOpen={isRequestSubmenuOpen}
                setIsRequestSubmenuOpen={setIsRequestSubmenuOpen}
            />
        </Router>
    );
}

function AppContent({ isFormSubmenuOpen, setIsFormSubmenuOpen, handleFormButtonClick, handleRequestButtonClick, isRequestSubmenuOpen, setIsRequestSubmenuOpen }) {
    const { isAuthenticated } = useAuth();
    const { pathname } = useLocation();
    const token = localStorage.getItem('token');
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    // useEffect(() => {
    //     if (token) {
    //         try {
    //             const decodedToken = JSON.parse(atob(token.split('.')[1]));
    //             const currentTime = Math.floor(Date.now() / 1000);
    //             const tokenTimeLeft = decodedToken.exp - currentTime;
    //             if (tokenTimeLeft > 0) {
    //                 setTimeLeft(tokenTimeLeft);
    //             }
    //         } catch (error) {
    //             console.error("Error decoding token:", error);
    //             setTimeLeft(0);
    //         }
    //     } else {
    //         setTimeLeft(0);
    //     }
    // }, [isAuthenticated]);

    // useEffect(() => {
    //     let timer;
    //     if (timeLeft > 0) {
    //         timer = setTimeout(() => {
    //             setTimeLeft(timeLeft - 1);
    //         }, 1000);
    //     }
    //     return () => clearTimeout(timer);
    // }, [timeLeft]);

    // const isFlashing = timeLeft <= 30;
    const showTimer = pathname !== '/login' && token;

    return (
        <div className="App">
            <AppBar position="static" sx={{ flexShrink: 0 }}>
                <Toolbar sx={{ backgroundColor: '#007acc', position: 'relative', width: '95%', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 0 }}>
                            {pathname !== '/login' && <SessionTimer />}
                    </Box>
                    {/* <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', zIndex: 1001 }}>
                        {showTimer && (
                            <>
                                <Button color="inherit" onClick={handleLogout} sx={{ fontFamily: 'Comfortaa, sans-serif', marginRight: '1rem' }}>
                                    Logout
                                </Button>
                                <Box
                                    sx={{
                                        color: 'white',
                                        padding: '8px 16px',
                                        borderRadius: '4px',
                                        fontFamily: 'Comfortaa, sans-serif',
                                        animation: isFlashing ? 'flash 1s linear infinite' : 'none',
                                        '@keyframes flash': {
                                            '0%': { backgroundColor: 'red' },
                                            '50%': { backgroundColor: 'transparent' },
                                            '100%': { backgroundColor: 'red' },
                                        },
                                    }}
                                >
                                    <Typography variant="body1" sx={{ fontFamily: 'Comfortaa, sans-serif'}}>
                                        Session expires in: {Math.floor(timeLeft / 60)}:{timeLeft % 60 < 10 ? `0${timeLeft % 60}` : timeLeft % 60}
                                    </Typography>
                                </Box>
                            </>
                        )}
                    </Box> */}
                    <Box sx={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', display: 'flex', justifyContent: 'center' }}>
                    {pathname !== '/login' && (
                        <Typography variant="h6" sx={{ fontFamily: 'Comfortaa, sans-serif', fontWeight: 'bold', fontSize: '24px' }}>
                            MSP4Growth
                        </Typography>
                    )}
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {pathname !== '/login' && ( 
                        <>
                        <Button
                            color="inherit"
                            onClick={handleFormButtonClick}
                            sx={{ fontFamily: 'Comfortaa, sans-serif' }}
                        >
                            Submit Request
                        </Button>
                        <Button 
                            color="inherit"
                            onClick={handleRequestButtonClick}
                            sx={{ fontFamily: 'Comfortaa, sans-serif' }}
                        >
                            Past Requests
                        </Button>
                        </>
                    )}
                    </Box>
                </Toolbar>
            </AppBar>
            <Box sx={{ padding: 1, flex: 1, minHeight: 0, overflow: 'hidden', boxSizing: 'border-box' }}>
                <Routes>
                    <Route path="/login" element={<LoginComponent />} />
                    <Route path="/" element={<ProtectedRoute><MapComponent isFormSubmenuOpen={isFormSubmenuOpen} setIsFormSubmenuOpen={setIsFormSubmenuOpen} isRequestSubmenuOpen={isRequestSubmenuOpen} setIsRequestSubmenuOpen={setIsRequestSubmenuOpen} /></ProtectedRoute>} />
                </Routes>
            </Box>
            {/* {isRequestSubmenuOpen && <RequestTable onViewOnMap={(geometry) => console.log("View geometry on map:", geometry)} />} */}
        </div>
    );
}

export default App;
